import { gql } from 'apollo-boost';
import { fetchGraphQL } from './graphQLservice'

export const createLeadQuery = gql`
query ($leadInput:LeadInputType){
    createLead(leadInput:$leadInput)
    {
      public_api_key
      user_confirmation_url
      user_cancel_url
      user_confirmation_url_action
      jsUrl
      name
      use_vcn
      shippingFirstName
      shippingLastName
      shippingFullName
      shippingAddLine1
      shippingAddLine2
      shippingAddCity
      shippingAddState
      shippingAddZipCode
      shippingAddCountry
      shippingPhone
      shippingEmail
      billingFirstName           
      billingLastName
      billingFullName             
      billingAddLine1
      billingAddLine2
      billingAddCity
      billingAddState
      billingAddZipCode
      billingAddCountry
      billingPhone
      billingEmail
      shipping_type
      entity_name
      orderID
      order_id
      shipping_amount
      tax_amount
      total
      send_link_Email            
      send_link_SMS
      customerID
      moveID
      estimatorID
      moveDailySheetID,
      financial_product_key
      redirectURL
      branchID 
    }
  }
`;